/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { tagName } from "@ember-decorators/component";
import { or } from "discourse/truth-helpers";
import dElement from "discourse/ui-kit/helpers/d-element";
import { i18n } from "discourse-i18n";

@tagName("")
export default class CategoryUnread extends Component {
  <template>
    {{#let (dElement (or @tagName "span")) as |TagName|}}
      <TagName class="category__badges" ...attributes>
        {{#if this.unreadTopicsCount}}
          <a
            class="badge new-posts badge-notification"
            href={{this.category.unreadUrl}}
            title={{i18n "topic.unread_topics" count=this.unreadTopicsCount}}
          >{{i18n
              "filters.unread.lower_title_with_count"
              count=this.unreadTopicsCount
            }}</a>
        {{/if}}
        {{#if this.newTopicsCount}}
          <a
            class="badge new-posts badge-notification"
            href={{this.category.newUrl}}
            title={{i18n "topic.new_topics" count=this.newTopicsCount}}
          >{{i18n
              "filters.new.lower_title_with_count"
              count=this.newTopicsCount
            }}</a>
        {{/if}}
      </TagName>
    {{/let}}
  </template>
}
